import { render, staticRenderFns } from "./email-summary.vue?vue&type=template&id=72d17c7d&scoped=true"
import script from "./email-summary.vue?vue&type=script&lang=js"
export * from "./email-summary.vue?vue&type=script&lang=js"
import style0 from "./email-summary.vue?vue&type=style&index=0&id=72d17c7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d17c7d",
  null
  
)

export default component.exports